import axios from 'CanExConfig/axios'

export const fetchCompany = async id => {
  const response = await axios(`/api/candidate/interview_requests/${id}/company`, {
    method: 'get',
  })

  return response.data
}
